import { useEffect } from "react";
import { Navigate } from "react-router-dom";
import Fallback from "components/Fallback";
import useFetchDefaultEntity from "services/hooks/useFetchDefaultEntity";

const RedirectSignedUser = ({ children }) => {
  const accessToken = localStorage.getItem("accessToken");
  const { isSuccess, data, refetch } = useFetchDefaultEntity();

  useEffect(() => {
    if (accessToken) {
      refetch();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accessToken]);

  const render = () => {
    if (!accessToken) {
      return children;
    }
    if (isSuccess) {
      if (data?.id) {
        return <Navigate to={`/dashboard?entityId=${data.id}`} />;
      } else {
        return <Navigate to={`/setup/create-entity`} />;
      }
    } else {
      return <Fallback />;
    }
  };

  return render();
};

export default RedirectSignedUser;
